export const ADD_TO_BASKET = "plp.addToBasket";
export const ALSO_SEARCHED = "plp.alsoSearched";
export const ANALYTICS_JLDATA_UPDATED = "JlDataUpdateComplete";
export const ANALYTICS_SEPARATOR = "|";
export const FILTER_APPLIED = "plp.filterApplied";
export const FILTER_INTERACTION = "plp.filterInteraction";
export const FILTER_REMOVED = "plp.filterRemoved";
export const FOUNDIT_CLICK = "foundit.clicked";
export const GLOBAL_INTERACTION = "global.interaction";
export const GLOBAL_SEARCH_INTERACTION = "global.searchInteraction";
export const MANAGED_IMPRESSION = "managedImpression";
export const PAGE_LOAD = "pageload";
export const PAGINATION = "plp.changePageNum";
export const PLP_VIEW_TYPE_SELECTED = "plp.viewTypeSelected";
export const SORT_OPTION_CHANGED = "plp.changeSortOption";
